import { baseUrl } from "../../utils/env";
import axios from "axios";
import {
  NEPAL_DESCRIPTION_LIST_FAIL,
  NEPAL_DESCRIPTION_LIST_REQUEST,
  NEPAL_DESCRIPTION_LIST_SUCCESS,
  NEPAL_DESCRIPTION_UPDATE_FAIL,
  NEPAL_DESCRIPTION_UPDATE_REQUEST,
  NEPAL_DESCRIPTION_UPDATE_SUCCESS,
} from "../constants/aboutNepalConstant";
import { toast } from "react-toastify";

export const listNepalDescription = () => async (dispatch) => {
  try {
    dispatch({ type: NEPAL_DESCRIPTION_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(`${baseUrl}/about_nepal`, config);

    dispatch({
      type: NEPAL_DESCRIPTION_LIST_SUCCESS,
      payload: data[0],
    });
  } catch (err) {
    dispatch({
      type: NEPAL_DESCRIPTION_LIST_FAIL,
      payload:
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message,
    });
  }
};
export const updateNepalDescription =
  (description, descriptionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: NEPAL_DESCRIPTION_UPDATE_REQUEST });
      const {
        adminLogin: { adminInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${adminInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `${baseUrl}/about_nepal/${descriptionId}`,
        {
          description,
        },
        config
      );

      toast.info("Description Updated Successfully", {
        autoClose: 1000,
      });
      dispatch({
        type: NEPAL_DESCRIPTION_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      toast.error("Fail To Update Description", {
        autoClose: 1000,
      });
      dispatch({
        type: NEPAL_DESCRIPTION_UPDATE_FAIL,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
